import { fbFunctions, db, analytics } from '@/fireinit';

// service fee for every item
const SERVICE_FEE = 2

const state = {
  userCity: 'Ankara',
  authUser: null,
  userDoc: null,
  displayedEvent: null,
  userBasket: null,
}

const mutations = {
  SET_USER: (state, p) => { state.userDoc = p },
  SET_USER_FOLLOWS: (state, p) => state.userDoc.follows = p,
  SET_AUTH_USER: (state, p) => { state.authUser = p },
  SET_USERNAME: (state, p) => { state.userDoc.username = p },
  SET_DISPLAYED_EVENT: (state, p) => state.displayedEvent = p,
  ADD_TO_SUBSCRIPTIONS: (state, p) => {
    state.userDoc.subscriptions.includes(p)
     ? state.userDoc.subscriptions = state.userDoc.subscriptions.filter(i => i !== p)
     : state.userDoc.subscriptions.push(p)
  },
  SET_USER_CITY: (state, p) => state.userCity = p,
  'SET_USER_BASKET': (state, p) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('p\n', p);
    }
    p.eventInfo.eventDateTime.startTime = new Date(p.eventInfo.eventDateTime.startTime)
    p.eventInfo.eventDateTime.endTime = new Date(p.eventInfo.eventDateTime.endTime)
    state.userDoc.userBasket = p

    if (process.env.NODE_ENV === 'development') {
      console.log('stat', state.userDoc.userBasket);
    }
  },
  "SET_EVENT_RULES_ACCEPTED": (state, p) => state.userDoc.userBasket.eventRulesIsAccepted = p,
  'SET_CUSTOMER_INFO': (state, p) => state.userDoc.userBasket.customerInfo = p,
  'SET_IS_CARD_INFO_CONFIRMED': (state, p) => state.userDoc.userBasket.isCardInfoConfirmed = p,

}

const actions = {
  async setUser({ commit, dispatch }, user) {
    commit('ui/SET_LOADING', true, { root: true })
    commit("SET_AUTH_USER", { displayName: user.displayName || '', uid: user.uid, isAnonymous: user.isAnonymous })
    // if (state.user) { return }
    analytics.setUserId(user.uid)
    analytics.setUserProperties({ 'user_anonymty': user.isAnonymous })

    try {
      const userDocRef = db.doc(`users/${user.uid}`).get()
      // TODO set security rule for user-private doc
      const userBasketRef = db.doc(`users/${user.uid}/user-private/user-basket`).get()
      // const userFollowsCol = db.collection(`users/${user.uid}/followings`).get()

      const [UD, UBD ] = await Promise.all([userDocRef, userBasketRef])

      const follows = await dispatch('fetchUserFollows', user)

      let u = {}
      if (UD.exists) {
        u = UD.data()
      }

      const preparedUser = {
        uid: user.uid,
        username: u.username || '',
        photoURL: u.photoURL || user.userPhotoURL,
        userCity: user.userCity || '',
        emailVerified: u.emailVerified || user.emailVerified,
        isAnonymous: u.isAnonymous || user.isAnonymous,
        userBasket: UBD.exists ? UBD.data() : null,
        follows,
        subscriptions: []
      }

      // if (user.userCity) dispatch("setUserCity", user.userCity);

      commit('SET_USER', preparedUser)


    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
      throw error
    }
    commit('ui/SET_LOADING', false, { root: true })
  },
  async fetchUserPersonalInfo({ state }, user) {
    try {

      const userDoc = await db.doc(`users/${state.userDoc.uid}/user-general/user-personal`).get()

      console.log('user doc personal :', userDoc.data());

      return userDoc.data()

    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
      throw error
    }
  },
  async setUserCity({ dispatch, commit }, city) {
    commit('SET_USER_CITY', city)

    // prepare cookie
    let d = new Date();
    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();

    document.cookie = `UCTY=${city};expires=${expires}`;

    // clean events store
    // commit("appData/SET_EVENTS", [], { root: true })

    // fetch city photo
    // try {
    //   const citySnap = await db.doc(`cities/${city}`).get()
    //   commit('SET_CITY_PHOTO', citySnap.data().cityCoverPhotoURL)
    // } catch (error) {
    //   if (process.env.NODE_ENV === 'development') {
    //     console.log(error)
    //   }
    // }
  },
  async chooseUsername({ commit }, username) {
    try {
      const updateUsername = fbFunctions.httpsCallable('updateUsername')
      const r = await updateUsername({ username })
      // set username on current state.user
      commit('SET_USERNAME', r.data)
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
      throw error
    }
  },
  // FOLLOW
  async fetchUserFollows({ state, commit  }, user) {
    if (!user.uid) {
      user.uid = state.authUser.uid
    }
    try {

      const qSnap = await db.collection(`users/${user.uid}/followings`).get()

      let follows = {
        stats: null,
        followings: []
      }
      // let followings = []
      if (!qSnap.empty) {
        qSnap.docs.forEach(doc => {
          // console.log('DATA', doc.data());
          const data = doc.data()
          if (doc.id !== '--stats--') {
            Object.keys(data).forEach(key => {
              follows.followings = data[key]
            })
          } else {
            follows.stats = data
          }
        })
      }
      if (process.env.NODE_ENV === 'development') {
        console.log('FOLLOWINGS', follows);
      }

      if (state.userDoc) {
        commit('SET_USER_FOLLOWS', follows)
      }
      return follows

    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
      throw error
    }
  },
  async addToUserFollowings({ dispatch, state }, payload) {

    try {

      if (!state.authUser || state.authUser.isAnonymous) {
        dispatch('ui/toggleModal', { name: 'SIGNIN_MODAL', state: true }, { root: true })
        return false
      } else {

        console.log('startFollowingAUser user', payload.user);

        const followedUser = {
          username: payload.user.data.username,
          displayName: payload.user.data.displayName,
          userID: payload.user.id,
          userAvatarURL: payload.user.data.userAvatarURL
        }
        const followingUser = {
          username: state.userDoc.username,
          displayName: state.userDoc.displayName || state.authUser.displayName,
          userID: state.authUser.uid,
          userAvatarURL: state.userDoc.photoURL ? state.userDoc.photoURL : ''
        }

        // console.log('PREPARED USERS', payload.isFollowing,  followedUser, 'following', followingUser);

        const startFollowingAUser = fbFunctions.httpsCallable('startFollowingAUser')
        const res = await startFollowingAUser({ followedUser, followingUser, isFollowing: payload.isFollowing })
        
        console.log('startFollowingAUser res: ', res);
        return res

      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
      throw error
    }
  },
  // USER BASKET
  async saveUserBasket({ commit }, basket) {
    // commit("SET_USER_BASKET", basket)
    console.log('basket to be sabed', basket);
    try {

      const setUserBasketFb = fbFunctions.httpsCallable('setUserBasket')
      const res = await setUserBasketFb({ basket: basket })

      // const userBasket = await db.doc(`users/${basket.userID}/user-private/user-basket`).get()

      // console.log('basket basket :', userBasket.data());

      // console.log('result of saveUserBasket', res);
      commit("SET_USER_BASKET", res.data)

    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
    }
  },
  async fetchUserBasket({ commit, rootState }) {
    console.log(' fetch user basket :');
    try {
      // fetch latest basket info
      const basket = await db.doc(`users/${rootState.user.uid}/user-private/user-basket`).get()

      // console.log('fetched basket.data() :', basket.data());
      // if the current event on page is the same as in the basket fill with the info
      // else set a new user basket
      if (basket.exists) {
        commit('SET_USER_BASKET', basket.data())
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
    }
  },
}


const getters = {
  userDoc: (state) => state.userDoc,
  displayedEvent: (state) => state.displayedEvent,
  userBasket: (state) => { return state.userDoc ? state.userDoc.userBasket : null },
  userCity: (state) => state.userCity,
  basketTotal: (state) => {
    if (!state.userDoc || !state.userDoc.userBasket) return
    if (!state.userDoc.userBasket.tickets.length) return 0;
    let totalPrice = 0;
    let totalItems = 0;
    state.userDoc.userBasket.tickets.forEach(item => {
      totalItems += item.numberOfTickets
      totalPrice += item.ticketPrice * item.numberOfTickets;
    });
    const serviceFee = totalItems * SERVICE_FEE
    totalPrice = totalPrice + serviceFee
    return { totalPrice, totalItems, serviceFee }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}